import { useState } from "react";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import { api, errorText } from "../lib/api";

export default function Newsletter({ dark = false }) {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/newsletter", { email });
      toast.success("You're on the list. The Monday Briefing lands next week.");
      setEmail("");
    } catch (err) { toast.error(errorText(err)); }
    setBusy(false);
  };
  return (
    <form onSubmit={submit} className="flex items-end gap-3" data-testid="newsletter-form">
      <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Your work email"
        className={`field ${dark ? "!border-white/30 focus:!border-white text-white placeholder:!text-white/50" : ""}`} data-testid="newsletter-email-input" />
      <button disabled={busy} className={`${dark ? "bg-white text-black hover:bg-[var(--red)] hover:text-white" : "btn-ink"} shrink-0 h-11 px-5 flex items-center gap-2 text-sm font-semibold transition-colors`} data-testid="newsletter-submit-btn">
        {busy ? "…" : "Sign up"} <ArrowRight size={16} />
      </button>
    </form>
  );
}
